module.exports = __webpack_public_path__ + "media/images/slide-4-8530cd5a37e52f665c6c01174c1704d4.jpg";